// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBE0gXIf_lHVorQ9XAQLSHBFVtBKfRZxto",
  authDomain: "timing-app-32b26.firebaseapp.com",
  projectId: "timing-app-32b26",
  storageBucket: "timing-app-32b26.firebasestorage.app",
  messagingSenderId: "476199049833",
  appId: "1:476199049833:web:d74345406f4f04f094e0f8",
  measurementId: "G-50RQ9LV58V"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics
const analytics = getAnalytics(app);

// Export the Auth instance
export const auth = getAuth(app);

// Export the Firestore DB
export const db = getFirestore(app);

// Enable offline persistence
enableMultiTabIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    // Multiple tabs open, persistence can only be enabled in one tab
    console.warn("Persistence failed: multiple tabs open. This is normal and not an error.");
  } else if (err.code === "unimplemented") {
    console.warn("Persistence is not available in this browser");
  } else {
    // Other persistence errors (like "Failed to obtain primary lease") are non-critical
    // They just mean persistence couldn't be enabled, but the app will still work
    console.warn("Persistence warning (non-critical):", err.message);
  }
});

export const storage = getStorage(app);